import {Sound} from '../../../../shared/scripts/Sound'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {UIDiscordInstance} from '../../discord/child_iframe/UIDiscordInstance'
import {SDKRequest} from '../../../../../shared/DiscordActivityTypes'
import {createDivIn, createSpanIn, setElementInnerHTML} from '../../../../shared/scripts/ui_utils/DomUtils'
import {UIDChildIFrameInstanceInit} from '../../discord/child_iframe/UIDChildIFrameInstanceInit'
import {AnalyticEventCategory, AnalyticEventType, AnalyticEventValue} from '../../../../../shared/entity_datas/EntityDatas'
import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {CA} from '../../../../shared/scripts/analytics/Analytics'

export class UIDRoomInviteFriendsController {
    private readonly inviteFriendsButton: HTMLDivElement

    constructor(container: HTMLElement) {
        if(!UIUtilsEjsVariables.isUserOnDiscord) return

        const inviteFriendsContainer = createDivIn(container, 'room_friend_container invite_discord_friends')
        if(UIUtilsEjsVariables.isUserOnDiscordMobile) inviteFriendsContainer.classList.add('discord_mobile')

        this.inviteFriendsButton = createDivIn(inviteFriendsContainer, 'btn_invite_friend btn_general')
        createSpanIn(this.inviteFriendsButton, 'btn_invite_friends_text', {key: 'strings:roomPage.inviteFriends', options: {context: 'discord'}})

        const discordInstance = UIDiscordInstance.getDiscordInstance()
        if(UIDRoomInviteFriendsController.shouldHideInviteFriendsButton(discordInstance)) {
            inviteFriendsContainer.hidden = true
            return
        }

        this.inviteFriendsButton.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)
            this.updateButtonTextWhileInviting()
            UIDRoomInviteFriendsController.sendClickAnalytic()
            return UIDiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.InviteFriends)
        }

        this.inviteFriendsButton.onmouseover = () => this.deanimateInviteFriendsButton()
    }

    private static shouldHideInviteFriendsButton(discordInstance: UIDChildIFrameInstanceInit): boolean {
        if(!discordInstance.inDiscordServer) return true
        if(!discordInstance.canInviteFriends) return true
        return false
    }

    private updateButtonTextWhileInviting() {
        const buttonTextChangeDuration = 3000
        setElementInnerHTML(this.inviteFriendsButton, {key: 'strings:roomPage.inviting'})
        setTimeout(() => {
            setElementInnerHTML(this.inviteFriendsButton, {key: 'strings:colonistCommon.utils.emptyString'})
            createSpanIn(this.inviteFriendsButton, 'btn_invite_friends_text', {key: 'strings:roomPage.inviteFriends', options: {context: 'discord'}})
        }, buttonTextChangeDuration)
    }

    private static sendClickAnalytic() {
        const eventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: AnalyticEventCategory.ABTestClickAnalytics,
            floatValue: AnalyticEventValue.InviteFriendButtonLeft,
        }
        void CA.sendAnalyticEvent(eventData)
    }

    private deanimateInviteFriendsButton() {
        this.inviteFriendsButton.classList.remove('btn-wiggle')
    }

    animateInviteFriendsButton() {
        this.inviteFriendsButton.classList.add('btn-wiggle')
    }
}
